import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

const SEARCH_MIN_ITEMS = 10;

type SelectItem = { label: string; subLabel?: string; note?: string; value: any };

@Component({
  selector: 'app-select-modal',
  templateUrl: './select-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectModalComponent implements OnInit {
  items: SelectItem[] = [];
  header: string;
  columns = 1;
  selectedValue: any;
  visibleItems: SelectItem[] = [];
  searchable = false;

  constructor(private modlCtrl: ModalController) {}

  ngOnInit() {
    this.visibleItems = this.items;
    this.searchable = this.items.length > SEARCH_MIN_ITEMS;
  }

  search(query: string) {
    const text = (query || '').trim().toLowerCase();
    this.visibleItems = this.items.filter((item) =>
      [item.label, item.subLabel, item.note]
        .join(' ')
        .toLowerCase()
        .includes(text)
    );
  }

  selectItem(value: any) {
    this.modlCtrl.dismiss(value.value);
  }

  close() {
    this.modlCtrl.dismiss();
  }
}
